/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {FmlxComboBox} from 'fmlx-common-ui';
import {GetRequest} from '../../../lib/AxiosHelper';
import {useManageAssignmentContext} from '../../../lib/contexLib';
import {API_EMPLOYEE} from '../../../const/Api';
import DepartmentDropdown from '../../../components/CommonDropdown/DepartmentDropdown';
import PracticeDropdown from '../../../components/CommonDropdown/PracticeDropdown';
import './SearchBoxes.scss';

const SearchBoxes = () => {
  const dispatch = useDispatch();
  const {employeeName, setDepartmentId, setPracticeId, setProjectId, setEmployeeName, projectState, projectId} =
    useManageAssignmentContext();

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [employeeDropdown, setEmployeeDropdown] = useState([]);
  const [loadingEmployee, setLoadingEmployee] = useState(true);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    fetchEmployee();
  }, []);

  const fetchEmployee = useCallback(() => {
    setLoadingEmployee(true);
    GetRequest(dispatch, API_EMPLOYEE)
      .then((response) => {
        const {data, responseCode} = response.data;
        if (responseCode === 0) {
          const emps = data.map((employee) => ({
            id: employee.id,
            text: employee.fullName,
            group: '',
            data: employee,
          }));
          setEmployeeDropdown(emps);
        }
      })
      .catch((error) => {
        // Handle error
      })
      .finally(() => {
        setLoadingEmployee(false);
      });
  }, [dispatch]);

  return (
    <div className="dropdown-boxes-container">
      <FmlxComboBox
        id="employee-dropdown"
        loading={loadingEmployee}
        placeholder="Employee"
        items={employeeDropdown}
        selectedItem={selectedEmployee}
        showClearChip={true}
        showClearInput={true}
        onClearInputValue={() => {
          setSelectedEmployee(null);
          setEmployeeName('');
        }}
        onChange={(value) => {
          setSelectedEmployee(value);
          if (value) {
            setEmployeeName(value.text);
          } else {
            setEmployeeName('');
          }
        }}
      />
      <DepartmentDropdown
        handleClearInputValue={() => setSelectedDepartment(null)}
        showClearChip={true}
        showClearInput={true}
        callbackChangeDepartment={(value) => {
          setSelectedDepartment(value);
          if (value) {
            setDepartmentId(parseInt(value.id));
          } else {
            setDepartmentId(0);
          }
        }}
      />
      <PracticeDropdown
        showClearChip={true}
        showClearInput={true}
        onClearValue={() => {
          setPracticeId(null);
        }}
        callbackChangePractice={(value) => {
          if (value) {
            setPracticeId(parseInt(value.id));
          } else {
            setPracticeId(null);
          }
        }}
        department={selectedDepartment}
      />
      <FmlxComboBox
        id="project-dropdown"
        placeholder="Project"
        items={projectState}
        selectedItem={selectedProject}
        showClearChip={true}
        showClearInput={true}
        onClearInputValue={() => {
          setSelectedProject(null);
        }}
        onChange={(project) => {
          setSelectedProject(project);
          if (project) {
            setProjectId(project.id);
          } else {
            setProjectId(null);
          }
        }}
      />
    </div>
  );
};

export default SearchBoxes;
